/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Cognos Analytics Home
 *| (C) Copyright IBM Corp. 2020, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define({
	homePageTitleLabel: 'Início',
	myContent: 'Meu conteúdo',
	teamContent: 'Conteúdo da equipe',
	folder: 'Pasta',
	files: 'Arquivo',
	actionMenu: 'Menu Ação',
	myFolder: 'Minhas pastas',

	emptyFolderNoContent: 'Sem conteúdo',

	//EmptyStates
	emptyRecentTitle: 'Você não visualizou nenhum conteúdo recentemente.',
	emptyStateTitle: 'Comece incluindo dados',
	emptyStateBody: 'Clique em Fazer upload de dados acima ou arraste e solte para fazer upload de dados.',
	emptySearchResultTitle: 'A sua procura não retornou nenhum resultado.',
	emptyPortalTitle: 'Nenhum portal',
	emptyPortalBody: 'Você não tem portais atualmente.',
	emptyWsProjectTitle: 'Comece criando um bloco de notas no Watson Studio.',
	emptyWsProjectBody: 'Ao retornar ao Cognos Analytics, seu bloco de notas aparecerá aqui.',
	emptyFilteredResultTitle: 'Os filtros aplicados não retornaram nenhum resultado.',
	emptyDialogViewTitle: 'Sem itens',
	removeFromRecents: 'Remover da recente',

	// Welcome Banner
	welcomeBannerGreeting: 'Olá. Bem-vindo ao Cognos Analytics.',
	welcomeBannerDescription: 'O Cognos Analytics permite que os usuários usem a análise de autoatendimento orientada por IA. Veja como as visualizações e a preparação e a descoberta de dados resultam em decisões mais confiantes.',
	welcomeBannerDescription_trialUser: 'É possível começar imediatamente conferindo nosso vídeo de introdução, o tour do produto e a guia Introdução.',
	takeTourButtonLabel: 'Faça um tour do produto',
	watchVideoButtonLabel: 'Assistir vídeo',
	// confirmation dialog
	hideWelcomeBannerMsg: 'Tem certeza de que deseja desativar o banner de boas-vindas de sua página inicial? É possível ativá-lo novamente em Perfil e configurações > Configurações > Geral a qualquer momento. ',
	hideWelcomeBannerTitle: 'Desativar o banner de boas-vindas',
	ok: 'OK',
	cancel: 'Cancelar',
	//howto video dialog
	modal_how_title: 'Vídeos de instruções',
	modal_overview_title: 'Assista à visão geral do Cognos Analytics',
	modal_how_play: 'Reproduzir vídeo',
	modal_how_video_title_overview: 'Visão Geral',
	modal_how_video_title_getStarted: 'Introdução à 11.2',
	modal_how_video_title_newUI: 'Bem-vindo à nova experiência do Cognos',
	modal_how_video_title_dataModule: 'Visão geral de módulos de dados',
	modal_how_video_title_explore: 'Visão geral de exploração de dados',
	modal_how_video_title_dashboard: 'Visão geral de painéis interativos',
	modal_how_video_title_reporting: 'Visão Geral da Geração de Relatórios',
	modal_how_video_title_mobile: 'O poder do Cognos na palma de suas mãos',

	// Toolbar
	search: 'Procurar',
	addFolder: 'Incluir Pasta',
	addLink: 'Incluir link',
	filter: 'Filtrar',
	sort: 'Classificação',
	settings: 'Configurações',
	tilesView: 'Visualização Lado a Lado',
	listView: 'Visualização de lista',
	columnView: 'Visualização de coluna',

	// Toolbar Actions
	sortBy: 'Classificar por',
	sortOrder: 'Pedir',
	name: 'Nome',
	modifiedTime: 'Modificado',
	type: 'Tipo',
	ascending: 'Ordem crescente',
	descending: 'Ordem decrescente',

	filterType: 'Tipo',
	filterModificationTime: 'Modificado',
	all: 'Todas',
	today: 'Hoje',
	yesterday: 'Ontem',
	pastWeek: 'Semana passada',
	pastMonth: 'Mês passado',
	resetFilters: 'Reconfigurar Filtros',

	filterSearchPlaceHolder: 'Filtrar por palavras-chave',

	resetFilterTag: 'Clique no X para reconfigurar os filtros.',
	filterTagToolTip: 'Filtros aplicados: %{appliedFilters}.',

	folderName: 'Nome da Pasta',
	addAFolder: 'Incluir uma pasta',
	add: 'Incluir',
	error: 'Erro',
	newFolderDefaultName: 'Nova Pasta',
	toastCreateNewFolder: 'A pasta %{nameOfFolder} foi criada em %{tabName}.',
	folderAdded: 'Pasta incluída',
	refresh: 'Atualizar',
	openFolder: 'Abrir pasta',

	addAUrl: 'Incluir uma URL',
	linkName: 'Nome da URL',
	linkNamePlaceholder: 'Inclua um nome de URL',
	linkDescription: 'Descrição (opcional)',
	linkDescriptionPlaceholder: 'Incluir uma descrição',
	linkUri: 'URL',
	linkUriPlaceholder: 'Inclua uma URL com um domínio aceitável',
	acceptableDomains: 'Domínios aceitáveis',
	viewAcceptableDomains: 'Visualizar domínios aceitáveis',
	mandatoryField: 'Campo obrigatório',
	linkAdded: 'URL incluída',
	toastCreateNewLink: '%{nameOfLink} foi incluído em %{tabName}.',
	noEntries: 'Não há entradas na lista de domínios aceitáveis. Entre em contato com o administrador.',

	compact: 'Compacto',
	short: 'Curto',
	default: 'Padrão',
	rowSize: 'Tamanho da Linha',

	// GroupyByTypes
	folders: 'Pastas',
	reports: 'Relatórios',
	dashboards: 'Painéis',
	data: 'Dados',
	packages: 'Pacotes',
	explorations: 'Explorações',
	stories: 'Histórias',
	notebooks: 'Notebooks',
	others: 'Outros',

	// Error Messages
	itemsOverLimit: 'O nome "%{itemName}" especificado excedeu o limite máximo (20). Especifique um nome diferente para continuar.',
	errorMessageLengthFolderName: 'Insira um nome de pasta com até 255 caracteres.',
	errorMessageLengthLinkName: 'Insira um nome de link com 255 caracteres ou menos.',
	toastLaunchPerspectiveError: 'Não é possível abrir %{objectType}.',
	errorNoAccessTitle: 'Parece que você não tem acesso a este conteúdo',
	errorNoAccessBody: 'Entre em contato com o administrador ou consulte o link a seguir:',
	errorEnableExternalContent: 'Ativando o conteúdo externo',

	//TableHeader
	lastModified: 'Última Modificação',
	location: 'Local',
	tenant: 'Locatário',

	// GetStartedTab
	getStartedLabel: 'Comece a usar o IBM Cognos Analytics',
	learningHowToLabel: 'Recursos de Aprendizagem',
	learningHowToDescription: 'Expanda seu conhecimento e obtenha assistência conectando-se à comunidade, lendo a documentação e assistindo aos vídeos.',
	learningHowToActionLabel: 'Abra a área de janela de aprendizagem',
	howToVideosLabel: 'Vídeos de instrução',
	howToVideosDescription: 'Saiba como usar o IBM Cognos Analytics e comece a obter insights sobre seus dados.',
	howToVideosActionLabel: 'Assistir vídeos',
	acceleratorCatalogLabel: 'Catálogo acelerado',
	acceleratorCatalogDescription: 'Navegue por um catálogo crescente de uso de mercado, guias de melhores práticas, visualizações customizadas e muito mais.',
	acceleratorCatalogActionLabel: 'Pesquisar catálogo',
	sampleSectionTitle: 'Exemplos',
	sampleSectionDescription: 'Teste com os exemplos que mostram tudo o que o Cognos Analytics pode oferecer.',
	// Samples Section
	createDashboardSampleTitle: 'Como criar seu primeiro painel',
	createDashboardSampleDescription: 'Comece sua jornada de análise com o Cognos Dashboards.',
	covid19SampleTitle: 'Painel da COVID',
	covid19SampleDescription: 'Explore a arte do possível com esse Cognos Dashboard analisando dados relacionados à COVID-19 e extensões customizadas.',
	sankeySampleTitle: 'Sankey',
	sankeySampleDescription: 'Expanda sua biblioteca de visualização com visualizações customizadas, como o Gráfico de Sankey.',
	viewAllSamplesActionLabel: 'Ver todas as amostras',
	byFeatureTitle: 'Por recurso',
	byFeatureDescription: 'Procure as amostras por recurso, como funcionalidades principais, controles de customização, extensões, blocos de notas e datas relativas.',
	byIndustryTitle: 'Por segmento de mercado',
	byIndustryDescription: 'Procure as amostras por setor, como automotivo, setor bancário e outros.',
	// SamplesTab
	sampleTabTitle: 'Inspire-se com nossas amostras pré-construídas',
	sampleTabLabel: 'Visite o Catálogo do Acelerador para obter mais amostras e extensões da IBM, de parceiros e seus clientes',

	// quickLaunch
	quickLaunchLabel: 'Ativação Rápida',
	expand: 'Expandir',
	collapse: 'Reduzir',

	// quickLaunch dialog
	quickLaunchModalLabel: 'Comece escolhendo o que deseja criar.',

	// contentPageView
	contentPageTitleLabel: 'Conteúdo',
	uploadFile: 'Fazer Upload dos Dados',
	new: 'Novo',
	create: 'Criar',
	more: 'Mais',

	// open dialog
	selectDataSourcesToAdd: 'Selecione as origens de dados a serem incluídas.',
	openDialogDefaultTitle: 'Abrir',

	// save dialog
	save: 'Salvar',
	saveAs: 'Salvar como',
	saving: 'Salvando...',
	selectedDestination: 'Destino selecionado: %{nameOfFolder}',
	toastDuplicateFileDifferentType: '\'%{nameOfItem}\' já existe com um tipo diferente. Escolha um nome diferente.',
	confirmOverwriteTitle: 'Confirme a substituição dos dados existentes',
	confirmOverwriteMsg: 'O arquivo \'%{nameOfFile}\' já existe. Deseja substituir seus dados pelos dados contidos no arquivo selecionado?',

	// copy move dialog
	copy: 'Copiar',
	move: 'Mover',
	copyOrMove: 'Copiar ou mover: ',
	copyOnly: 'Copiar ',
	createShortcut: 'Criar atalho',
	createShortcutDialogTitle: 'Criar atalho: ',

	// External asset types
	wsProject: 'Projeto do Watson Studio',
	externalContentTypeWs: 'Watson Studio',

	// Asset Types
	package: 'Pacote',
	dataModule: 'Módulo de dados',
	exploration: 'Exploração',
	mode: 'Modo',
	live: 'Ativo',
	snapshot: 'Captura instantânea',
	noSnapshotsFound: 'Nenhuma Captura Instantânea encontrada',
	uploadedFile: 'Arquivo transferido por upload',
	fileUpload: 'Fazer Upload dos Dados',
	dataSetEx: 'Conjunto de dados',
	externalRepository: 'Repositório externo',
	queryMode: 'Modo de consulta',
	queryModeCompatible: 'Compatível',
	queryModeDynamic: 'Dinâmico',
	report: 'Relatório',
	activeReport: 'Relatório ativo',
	query: 'Consulta',
	analysis: 'Análise',
	dashboard: 'Painel',
	dashboardTemplate: 'Gabarito do Painel Digital',
	jupyterNotebook: 'Anotações',
	wsNotebook: 'Bloco de notas do Watson Studio',
	jupyter: 'Jupyter',
	ws: 'Watson Studio',
	story: 'História',
	workspace: 'Espaço de Trabalho',
	pagelet: 'Página',
	content: 'Conteúdo',
	directory: 'Namespaces',
	dataSet: 'Conjunto de dados',
	powerPlayCube: 'Cubo do PowerPlay',
	powerPlayReport: 'Relatório do PowerPlay',
	powerPlay8Report: 'Relatório do PowerPlay',
	powerPlay8ReportView: 'Visualização de relatório do PowerPlay',
	reportTemplate: 'Modelo de Relatório',
	packageConfigurations: 'Configuração do pacote',
	agent: 'Agent',
	agentDefinition: 'Definição do agente',
	agentDefinitionView: 'Visualização de Agente',
	dataMovementTask: 'Tarefa de movimentação de dados',
	dataMovementTaskAlias: 'Alias da tarefa de movimentação de dados',
	document: 'Documento',
	DocumentRetention: 'Propriedades do documento',
	jobDefinition: 'Definição da Tarefa',
	job: 'Tarefa',
	metricsDataSourceETLTask: 'Tarefa de ETL da origem de dados de métrica',
	metricsExportTask: 'Tarefa de Exportação de Métrica',
	metricsFileImportTask: 'Tarefa de importação do arquivo de métrica',
	metricsMaintenanceTask: 'Tarefa de Manutenção de Métrica',
	planningTask: 'Tarefa de planejamento',
	shortcut: 'Atalho',
	URL: 'URL',
	launchable: 'Acionável',
	dataSetFolder: 'Pasta do conjunto de dados',
	ViewAccessibleLabel: 'Veja o %{label}',
	overrideReportOptions: 'Substituir as opções de relatório padrão',
	formats: 'Formats',
	saveReport: 'Salvar o relatório',
	promptForValues: 'Avise-me',
	reportView: 'Visualização de Relatório',
	html: 'html',
	pdf: 'pdf',
	spreadsheetML: 'Excel',
	xlsxData: 'Dados do Excel',
	csv: 'csv',
	xml: 'xml',
	txt: 'txt',
	//Details
	details: 'Detalhes',
	open: 'Abrir',
	created: 'Criado',
	modified: 'Modificado',
	owner: 'Proprietário',
	dataSource: 'Origem de Dados',
	share: 'Compartilhar',
	addToFavorites: 'Adicionar a Favoritos',
	properties: 'Propriedades',
	detailsEmptyStateBody: 'Selecione um item para visualizar seus detalhes',
	editNameAndDescription: 'Editar Nome e Descrição',
	none: 'Nenhum',

	//rename dialog
	nameInvalid: 'O nome é inválido',
	namePlaceholder: 'Digite um nome',
	description: 'Descrição',
	descriptionInvalid: 'A descrição não pode exceder 350 caracteres. ',
	descriptionPlaceholder: 'Inserir uma descrição',
	errorMessageApostropheError: 'Insira um nome de arquivo que não contenha os caracteres \' e "',
	renameCollisionError: '%{name} já existe. Tente um nome diferente.',
	unknownRenameError: 'A renomeação do item falhou. Entre em contato com o administrador para obter assistência.',

	//types
	xls: 'xls',
	xlsx: 'xlsx',

	unableToOpenFolderMsg: 'Não é possível abrir a pasta especificada.',

	//Upload
	uploadToFolder: "Faça upload para o <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>%{launchAction}",
	uploadAndLaunch: "Faça upload para o <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> e ative o %{launchAction}",
	quickUpload: "Upload rápido",
	quickUploadAndLaunch: "Arraste e solte arquivos para fazer upload para o <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> e abrir em um dos espaços a seguir.",
	unsupportedFilesSingle: "O %{files} não foi transferido por upload porque é inválido para a ativação rápida.",
	unsupportedFilesMultiple: "Os arquivos não fizeram upload porque todos os arquivos que você seleciona devem ser válidos para usar a Ativação rápida.",
	unsupportedFilesSingleInvalid: "O %{files} é inválido.",
	unsupportedFilesMultipleInvalid: "Os %{files} são inválidos.",
	supportedFileTypes: "Somente os tipos de arquivo a seguir são permitidos: %{extensions}.",
	uploadDragAndDrop: "Arrastar e Soltar",
	uploadDragAndDropMessage: "Arraste e solte seu arquivo aqui para fazer upload dele em <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>",

	// searchBar
	searchWasSaved: 'O critério de procura \'%{searchTerm}\' foi salvo.',
	searchWasntSaved: 'O critério de procura \'%{searchTerm}\' não foi salvo.',
	searchSuggestions: 'Sugestões (Suggestions)',
	savedSearch: 'Procuras Salvas',
	searchWasDeleted: 'O critério de procura \'%{searchTerm}\' foi excluído.',
	searchWasntDeleted: 'O critério de procura \'%{searchTerm}\' não foi excluído.',
	savedBarTitle: 'Procurar o Cognos Analytics',
	searchContentPageTitle: 'Procurar',
	searchContentPageTitleLabel: 'Mostrando resultados para \'%{searchTerm}\'',
	showingSearchRsult: 'Mostrando %{resultCount} itens',
	saveSearch: 'Salvar procura',
	saveTenSearches: 'É possível salvar 10 procuras.',
	deleteASearch: 'Exclua uma para salvar outra.',
	close: 'Fechar',

	//recent view
	recents: 'Recente',
	noAccessRecent: 'Sem acesso',
	noAccessRecentMsg: 'Você não possui acesso a esse ativo. Ele pode ter sido desativado ou excluído, ou sua permissão pode ter sido reduzida. Verifique o estado do ativo em sua localização de origem esperada. É possível remover o ativo de seus itens recentes clicando em OK.',
	noAccessMsg: 'Você não possui acesso a esse ativo. Ele pode ter sido desativado ou excluído, ou sua permissão pode ter sido reduzida.',

	//contextToolbar
	itemsSelected: '%{nameOfSelection} itens selecionados',
	itemSelected: '%{nameOfSelection} item selecionado'

});